document
    .querySelectorAll('.content .wp-block-gallery')
    .forEach((gallery) => {

        let offset = 0;

        const
            wrapper = document.createElement('div'),
            galleryRect = gallery.getBoundingClientRect();
        wrapper.className = 'w-full overflow-x-scroll desktop:overflow-hidden relative rounded-md no-scrollbar';
        wrapper.style['min-height'] = galleryRect.height;

        const images = gallery.querySelectorAll('.wp-block-image'),
            stepSize = galleryRect.width,
            maxOffset = galleryRect.width * (images.length - 1) * -1,
            leftStick = document.createElement('div'),
            rightStick = document.createElement('div'),
            slidePrev = () => {

                if (offset < 0)
                    offset += stepSize;
                else
                    offset = maxOffset;

                gallery.style.setProperty('transform', `translateX(${offset}px)`);
            },
            slideNext = () => {

                if (offset > maxOffset)
                    offset -= stepSize;
                else
                    offset = 0;

                gallery.style.setProperty('transform', `translateX(${offset}px)`);
            };

        wrapper.appendChild(leftStick);
        wrapper.appendChild(rightStick);

        gallery.parentNode.insertBefore(wrapper, gallery);
        wrapper.appendChild(gallery);

        leftStick.className = 'wp-block-gallery-stick wp-block-gallery-stick--left';
        leftStick.addEventListener('click', slidePrev);

        rightStick.className = 'wp-block-gallery-stick wp-block-gallery-stick--right';
        rightStick.addEventListener('click', slideNext);
    });